import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("data_estrategy.title_manage_evaluation_report"))),
      ]),
      _vm._t("default"),
      _c(
        "actions-component",
        { attrs: { class_table: _vm.getClassTable } },
        [
          _c("template", { slot: "description" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("data_estrategy.subtitle_manage_evaluation_report")
                ) +
                " "
            ),
          ]),
        ],
        2
      ),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(
                  VContainer,
                  { staticClass: "justify-center", attrs: { fluid: "" } },
                  [
                    _c(
                      VForm,
                      {
                        ref: "form",
                        staticClass: "form mt-2",
                        attrs: { "lazy-validation": "" },
                        model: {
                          value: _vm.valid,
                          callback: function ($$v) {
                            _vm.valid = $$v
                          },
                          expression: "valid",
                        },
                      },
                      [
                        _c(
                          VRow,
                          { attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Titulo")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "9", lg: "4" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    filled: _vm.readonly,
                                    outlined: !_vm.readonly,
                                    readonly: _vm.readonly,
                                    "hide-details": "auto",
                                    dense: "",
                                    rules: _vm.rules.general,
                                  },
                                  model: {
                                    value: _vm.report.title,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.report, "title", $$v)
                                    },
                                    expression: "report.title",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Organización")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "9", lg: "4" } },
                              [
                                _c(VCombobox, {
                                  attrs: {
                                    multiple: "",
                                    chips: "",
                                    outlined: "",
                                    dense: "",
                                    items: _vm.organizations,
                                    "item-value": "id",
                                    "item-text": "name",
                                    rules: _vm.rules.general,
                                    attach: true,
                                  },
                                  model: {
                                    value: _vm.report.organizations,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.report, "organizations", $$v)
                                    },
                                    expression: "report.organizations",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          VRow,
                          { staticClass: "mt-2", attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Link")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "9", lg: "10" } },
                              [
                                _c(VTextField, {
                                  attrs: {
                                    filled: _vm.readonly,
                                    outlined: !_vm.readonly,
                                    readonly: _vm.readonly,
                                    "hide-details": "auto",
                                    dense: "",
                                    rules: _vm.rules.general,
                                    type: "url",
                                  },
                                  model: {
                                    value: _vm.report.link,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.report, "link", $$v)
                                    },
                                    expression: "report.link",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          VRow,
                          { staticClass: "mt-2", attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Horas de actualización")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "9", lg: "10" } },
                              [
                                _c(VCombobox, {
                                  attrs: {
                                    multiple: "",
                                    chips: "",
                                    outlined: "",
                                    dense: "",
                                    items: _vm.update_hours,
                                    rules: _vm.rules.update_hours,
                                    attach: true,
                                  },
                                  model: {
                                    value: _vm.report.update_hours,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.report, "update_hours", $$v)
                                    },
                                    expression: "report.update_hours",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          VRow,
                          { staticClass: "mt-2", attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Descripción")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "9", lg: "10" } },
                              [
                                _c(VTextarea, {
                                  attrs: {
                                    "hide-details": "auto",
                                    outlined: !_vm.readonly,
                                    dense: "",
                                    filled: _vm.readonly,
                                    readonly: _vm.readonly,
                                    rules: _vm.rules.general,
                                    required: "",
                                    rows: "4",
                                  },
                                  model: {
                                    value: _vm.report.description,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.report, "description", $$v)
                                    },
                                    expression: "report.description",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          VRow,
                          { staticClass: "mt-2", attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("En mantenimiento")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(VSwitch, {
                                  model: {
                                    value: _vm.report.maintenance,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.report, "maintenance", $$v)
                                    },
                                    expression: "report.maintenance",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          VRow,
                          { staticClass: "mt-2", attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { staticClass: "text-right" },
                              [
                                _c(
                                  VBtn,
                                  {
                                    staticClass: "mb-3",
                                    attrs: { type: "button", color: "primary" },
                                    on: { click: _vm.updateInfo },
                                  },
                                  [_vm._v(" Actualizar ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }